import { connect } from 'react-redux';
import SettingGateway from './index';
import { mapStateToProps } from './index.props';

export default connect(mapStateToProps)(SettingGateway);
